import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card system-view"
}
const _hoisted_2 = { class: "card-content" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 0 }

import { computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { System } from '@/models/system.model';
import { Actions } from '@/store';
import { HardwareComponent } from '@/models/hardware.model';
import Case from '@/components/system/components/Case.vue';
import Motherboard from '@/components/system/components/Motherboard.vue';
import CPU from '@/components/system/components/CPU.vue';
import CPUCooler from '@/components/system/components/CPUCooler.vue';
import Memory from '@/components/system/components/Memory.vue';
import GPU from '@/components/system/components/GPU.vue';
import Monitor from '@/components/system/components/Monitor.vue';
import GenericComponent from '@/components/system/components/GenericComponent.vue';
import PowerSupply from './components/PowerSupply.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SystemView',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();
const system = computed<System>(() => store.state.system);

onMounted(() => {
  store.dispatch(Actions.GetHardwareComponents);
  store.dispatch(Actions.GetSystemByName, route.params.slug);
});

const getComponent = (id: number): HardwareComponent | null => {
  return (
    store.state.hardwareComponents.find(
      (c: HardwareComponent) => c.id === id,
    ) || null
  );
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(system))
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: `/images/${_unref(system).image}`,
            width: "240"
          }, null, 8, _hoisted_3),
          (getComponent(_unref(system).case))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("h2", null, _toDisplayString(_unref(system).name), 1),
                _createElementVNode("ul", null, [
                  _createVNode(Case, {
                    component: getComponent(_unref(system).case),
                    full: ""
                  }, null, 8, ["component"]),
                  _createVNode(Motherboard, {
                    component: getComponent(_unref(system).motherboard),
                    full: ""
                  }, null, 8, ["component"]),
                  _createVNode(PowerSupply, {
                    component: getComponent(_unref(system).powersupply),
                    full: ""
                  }, null, 8, ["component"]),
                  _createVNode(CPU, {
                    component: getComponent(_unref(system).cpu),
                    full: ""
                  }, null, 8, ["component"]),
                  _createVNode(CPUCooler, {
                    component: getComponent(_unref(system).cpucooler),
                    full: ""
                  }, null, 8, ["component"]),
                  _createVNode(Memory, {
                    component: getComponent(_unref(system).memory),
                    full: ""
                  }, null, 8, ["component"]),
                  _createVNode(GPU, {
                    component: getComponent(_unref(system).gpu),
                    full: ""
                  }, null, 8, ["component"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(system).otherComponents, (c) => {
                    return (_openBlock(), _createBlock(GenericComponent, {
                      component: getComponent(c),
                      full: ""
                    }, null, 8, ["component"]))
                  }), 256)),
                  _createVNode(Monitor, {
                    component: getComponent(_unref(system).monitor),
                    full: ""
                  }, null, 8, ["component"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_router_link, { to: "/hardware" }, {
          default: _withCtx(() => [
            _createTextVNode("Back")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: '/system/' + _unref(system).slug + '/edit'
        }, {
          default: _withCtx(() => [
            _createTextVNode("Edit")
          ]),
          _: 1
        }, 8, ["to"])
      ]))
    : _createCommentVNode("", true)
}
}

})